import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.29.7_react-dom@19.2.7_react@19.2.7__react@19.2.7_sass@1.77.4/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["SeoKeywordProvider"] */ "/app/web/components/product-series/SeoKeywordProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportApplicationsSection"] */ "/app/web/components/support/SupportApplicationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportCommitmentSection"] */ "/app/web/components/support/SupportCommitmentSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportContactFormSection"] */ "/app/web/components/support/SupportContactFormSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportCustomizedSection"] */ "/app/web/components/support/SupportCustomizedSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportDecoratorSection"] */ "/app/web/components/support/SupportDecoratorSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportHeroSection"] */ "/app/web/components/support/SupportHeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportMarketingSalesSection"] */ "/app/web/components/support/SupportMarketingSalesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportQualityControlSection"] */ "/app/web/components/support/SupportQualityControlSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportQuoteSection"] */ "/app/web/components/support/SupportQuoteSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportRemoteSection"] */ "/app/web/components/support/SupportRemoteSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportRequestProcessSection"] */ "/app/web/components/support/SupportRequestProcessSection.tsx");
